

export default class Exercise {
  constructor(categories = [], equipment = [], explanation = [[], []], id = null, musclegroup = [], name = '', tags = [], trainer = null, video = [], publishable = null) {
    this.categories = categories;
    this.equipment = equipment;
    this.equipment_alt = equipment; // for new equipment model/structure
    this.explanation = explanation;
    this.id = id;
    this.musclegroup = musclegroup;
    this.name = name;
    this.publishable = publishable;
    this.tags = tags;
    this.trainer = trainer;
    this.video = video;
  }
}
